import { render, staticRenderFns } from "./ContractorInfo.vue?vue&type=template&id=23a2b9ac&"
import script from "./ContractorInfo.vue?vue&type=script&lang=js&"
export * from "./ContractorInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports